module.exports = __webpack_public_path__ + "img/icone_sensor_removido_vermelho.3b490dcb.png";